<template>
  <v-dialog v-model="dialogOpen" max-width="450" persistent>
    <!-- TODO: COMBINE THESE INTO CALCULATED VARIABLES -->
    <!-- IMPERSONATE DIALOG -->
    <v-card v-if="dialogType === 'impersonate'">
      <v-toolbar color="white" class="px-2">
        <v-toolbar-title> Impersonate {{ impersonationType }} </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="py-2" style="color: black">
        <p>
          You are about to impersonate {{ name }}. This will allow to to manage
          their profile as if you were an administrator of their account.
        </p>
        <p></p>
        <p>Would you like to continue?</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="btncolor"
          class="text-none mr-2 mb-2"
          style="width: 80px"
          variant="text"
          @click="cancelButton"
        >
          Cancel
        </v-btn>
        <v-btn
          color="btncolor"
          class="text-none mb-2"
          style="width: 140px"
          variant="flat"
          @click="impersonateButton"
        >
          Impersonate
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- DISABLE IMPERSONATION -->
    <v-card v-if="dialogType === 'disableImpersonate'">
      <v-toolbar color="white" class="px-2">
        <v-toolbar-title> Stop Impersonation </v-toolbar-title>
      </v-toolbar>
      <!--      <v-card-title class="headline">Stop Impersonation</v-card-title>-->
      <v-card-text class="py-2" style="color: black">
        <p>You are about to stop impersonating {{ name }}.</p>
        <p></p>
        <p>Would you like to continue?</p>
      </v-card-text>
      <v-card-actions class="mb-2">
        <v-spacer></v-spacer>
        <v-btn
          color="btncolor"
          class="text-none"
          style="width: 80px"
          variant="text"
          @click="cancelButton"
        >
          Cancel
        </v-btn>
        <v-btn
          color="btncolor"
          class="mr-2 text-none"
          style="width: 100px"
          variant="flat"
          @click="disableImpersonateButton"
        >
          Stop
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- IMPERSONATION ERROR -->
    <v-card v-if="dialogType === 'impersonateError'">
      <v-toolbar color="white" class="px-2">
        <v-toolbar-title> Impersonate Error </v-toolbar-title>
      </v-toolbar>
      <!--      <v-card-title class="headline">Impersonation Error</v-card-title>-->
      <v-card-text class="py-0" style="color: black">
        <p>There was an error impersonating {{ name }}.</p>
        <p></p>
        <p>Please contact support for assistance.</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="btncolor"
          class="text-none"
          style="width: 80px"
          variant="text"
          @click="cancelButton"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    dialogType: {
      type: String,
      default: "impersonate",
    },
    name: {
      type: String,
      default: "",
    },
    impersonationType: {
      type: String,
      default: "Brokerage",
    },
  },
  data() {
    return {
      dialogOpen: this.dialog,
    };
  },
  watch: {
    dialog() {
      this.dialogOpen = this.dialog;
    },
  },
  methods: {
    cancelButton() {
      this.$emit("cancel");
    },
    impersonateButton() {
      this.$emit("impersonate");
    },
    disableImpersonateButton() {
      this.$emit("disable");
    },
  },
};
</script>
